/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdFeedbacks200,
  GetApiV1ClassroomdisciplineIdFeedbacks401,
  GetApiV1ClassroomdisciplineIdFeedbacks404,
  GetApiV1ClassroomdisciplineIdFeedbacksPathParams,
  GetApiV1ClassroomdisciplineIdFeedbacksQueryParams,
  GetApiV1ClassroomdisciplineIdFeedbacksQueryResponse,
} from "../../types/classPlanningFeedbacksController/GetApiV1ClassroomdisciplineIdFeedbacks.ts";
import { feedbackListItemViewModelSchema } from "../feedbackListItemViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdFeedbacksPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksPathParams>;

export const getApiV1ClassroomdisciplineIdFeedbacksQueryParamsSchema = z
  .object({
    PageNumber: z.optional(z.coerce.number().int()),
    PageSize: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdFeedbacks200Schema = z.array(
  z.lazy(() => feedbackListItemViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacks200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdFeedbacks401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacks401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdFeedbacks404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacks404>;

export const getApiV1ClassroomdisciplineIdFeedbacksQueryResponseSchema = z.lazy(
  () => getApiV1ClassroomdisciplineIdFeedbacks200Schema,
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksQueryResponse>;
